import Modal from 'bootstrap/js/dist/modal.js'

export default class RemoteModal {
  constructor(element) {
    this.element = element
    this.contentElement = element?.querySelector('[data-remote-modal-content]')
    this.dialogElement = element?.querySelector('[data-remote-modal-dialog]')
    this.loadingTemplateElement = element?.querySelector('[data-remote-modal-loading-template]')
    this.errorTemplateElement = element?.querySelector('[data-remote-modal-error-template]')
    this.instance = element ? Modal.getOrCreateInstance(element) : null

    this.handleHidden = this.handleHidden.bind(this)

    this.element?.addEventListener('hidden.bs.modal', this.handleHidden)
  }

  get isAvailable() {
    return Boolean(this.element && this.contentElement && this.instance)
  }

  open() {
    if (!this.isAvailable) {
      return
    }

    this.instance.show()
  }

  openLoading() {
    this.showLoading()
    this.open()
  }

  close() {
    this.instance?.hide()
  }

  showLoading() {
    this.showTemplate(this.loadingTemplateElement)
    this.element?.setAttribute('aria-busy', 'true')
  }

  showError() {
    this.showTemplate(this.errorTemplateElement)
    this.element?.removeAttribute('aria-busy')
    this.instance?.handleUpdate()
  }

  showTemplate(template) {
    if (!this.contentElement || !(template instanceof HTMLTemplateElement)) {
      return
    }

    const content = template.content.cloneNode(true)

    this.contentElement.replaceChildren(content)
  }

  setContent(html) {
    if (!this.contentElement) {
      return
    }

    this.contentElement.innerHTML = html
    this.element.removeAttribute('aria-busy')
    this.instance?.handleUpdate()

    this.element.dispatchEvent(
      new CustomEvent('remote-modal:content-loaded', {
        bubbles: true,
      }),
    )
  }

  clear() {
    this.contentElement?.replaceChildren()
    this.element?.removeAttribute('aria-busy')
  }

  handleHidden() {
    this.clear()
  }
}
